<script setup lang="ts">
import { computed } from 'vue'
import { Dieline, PlanoLayout } from '@/Composables/useCustomSizeLayout'
import DielineShape from '@/Pages/CustomSize/DielineShape.vue'

const props = defineProps<{
    planoWidth: number
    planoHeight: number
    dieline: Dieline
    layout: PlanoLayout
    safeMargin: number
}>()

const formatCm = (value: number) => new Intl.NumberFormat('id-ID', { maximumFractionDigits: 2 }).format(value)

const fontSize = computed(() => Math.max(props.planoWidth, props.planoHeight) * 0.025)
const labelGutter = computed(() => fontSize.value * 2.2)

const viewBox = computed(() =>
    `${-labelGutter.value} ${-labelGutter.value} ${props.planoWidth + labelGutter.value * 1.2} ${props.planoHeight + labelGutter.value * 1.2}`
)
</script>

<template>
    <svg :viewBox="viewBox" class="h-auto max-h-[560px] w-full" preserveAspectRatio="xMidYMid meet">
        <rect :width="planoWidth" :height="planoHeight" fill="#f9a8d4" stroke="#be185d" stroke-width="1"
            vector-effect="non-scaling-stroke" />

        <g v-for="(placement, index) in layout.placements" :key="`placement-${index}`">
            <rect :x="placement.x" :y="placement.y"
                :width="placement.rotated ? layout.cellHeight : layout.cellWidth"
                :height="placement.rotated ? layout.cellWidth : layout.cellHeight" fill="#fff200" stroke="#a16207"
                stroke-width="0.5" vector-effect="non-scaling-stroke" />
            <DielineShape :dieline="dieline" :x="placement.x + safeMargin" :y="placement.y + safeMargin"
                :rotated="placement.rotated" />
        </g>

        <text :x="planoWidth / 2" :y="-fontSize * 0.8" :font-size="fontSize" text-anchor="middle" fill="#111827">
            {{ formatCm(planoWidth) }} cm
        </text>
        <text :x="-fontSize * 0.8" :y="planoHeight / 2" :font-size="fontSize" text-anchor="middle" fill="#111827"
            :transform="`rotate(-90 ${-fontSize * 0.8} ${planoHeight / 2})`">
            {{ formatCm(planoHeight) }} cm
        </text>
    </svg>
</template>
